// react
import React, { Component, useEffect } from 'react';

// third-party
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import axios from 'axios';
// import ReactPlayer from 'react-player/lazy'

// application
import Indicator from '../header/Indicator';
import {
    Search20Svg,
    Heart20Svg,
    MobileCartSvg,
} from '../../svg';
import {
    NavHomeIcon,
    NavCategoryIcon,
    NavOrdersIcon,
    NavCartIcon,
    NavAccountIcon,
    NavWhatsappIcon,
    NavCartHeaderIcon,
    NavWishlistIcon,
} from './MobileNavIcons';
import { mobileMenuOpen } from '../../store/mobile-menu';
import Search from '../header/Search';
// import FloatingWhatsApp from 'react-floating-whatsapp';
import 'react-floating-whatsapp-button/dist/index.css';
import { getCartList } from '../../services/cartService';

class MobileHeader extends Component {
    constructor(props) {
        super(props);

        const savedCartTotal = localStorage.getItem('cart_total');
        this.state = {
            searchOpen: false,
            cartTotal : savedCartTotal !== null ? parseInt(savedCartTotal, 10) : 0,
        };
        this.searchInput = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        const { searchOpen } = this.state;

        if (searchOpen && searchOpen !== prevState.searchOpen && this.searchInput.current) {
            this.searchInput.current.focus();
        }

        if (prevProps.updateStatus !== this.props.updateStatus && this.props.token) {
            this.getCart();
        }

        if (prevProps.token && !this.props.token) {
            this.setState({ cartTotal: 0 });
            localStorage.setItem('cart_total', 0);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('cart:count_updated', this.handleCartCountUpdated);
    }

    handleCartCountUpdated = (e) => {
        const count = typeof e?.detail === 'number'
            ? e.detail
            : (typeof e?.detail?.count === 'number'
                ? e.detail.count
                : parseInt(localStorage.getItem('cart_total') || '0', 10));
        this.setState({ cartTotal: count });
    };

    handleBack = () => {
        const { history } = this.props;
        if (window.history.length > 1) {
            history.goBack();
        } else {
            history.push('/');
        }
    };

    handleOpenSearch = () => {
        this.setState(() => ({ searchOpen: true }));
    };

    handleCloseSearch = () => {
        this.setState(() => ({ searchOpen: false }));
    };

    getCart = async () => {
        const { token } = this.props;
        if (!token) return;
        try {
            const { total } = await getCartList(token);
            this.setState({ cartTotal: total });
        } catch (error) {
            this.setState({ cartTotal: 0 });
        }
    };

    componentDidMount() {
        const { token } = this.props;
        window.addEventListener('cart:count_updated', this.handleCartCountUpdated);
        if (token) {
            this.getCart();
        }
    }
    

    render() {
        const { openMobileMenu, wishlist, cart,updateStatus,token } = this.props;
        const { cartTotal } = this.state;
        const currentPath = this.props.location?.pathname || '';
        const isHome = currentPath === '/';
        const isCartPage = currentPath === '/shop/cart' || currentPath.startsWith('/shop/cart');
        
        // console.log(cartTotal);
        // useEffect(() => {
        //     const getCart = async () => {
        //       const result = await axios({
        //         method: "GET",
        //         url: `${process.env.REACT_APP_HOST_API}/cart/list`,
        //         headers: {
        //           Authorization: `Bearer ${token}`,
        //         },
        //       });
        //       const totalQty = result.data?.response.map((item) => item.qty);
        //       // console.log(totalQty);
        //       let sum = 0;
        
        //       for (let i = 0; i < totalQty.length; i++) {
        //         sum += totalQty[i];
        //       }
        //       this.setState({cartTotal: sum});
        //     };
        //     if(token){
    
        //         getCart();
        //     }
        //     if (updateStatus) {
        //         const getCart = async () => {
        //             const result = await axios({
        //               method: "GET",
        //               url: `${process.env.REACT_APP_HOST_API}/cart/list`,
        //               headers: {
        //                 Authorization: `Bearer ${token}`,
        //               },
        //             });
        //             const totalQty = result.data?.response.map((item) => item.qty);
        //             let sum = 0;
              
        //             for (let i = 0; i < totalQty.length; i++) {
        //               sum += totalQty[i];
        //             }
        //             this.setState({cartTotal: sum});
        //           };
    
        //       getCart();
        //     }
        //   }, [token, updateStatus]);
    

        // console.log(cart);
        // console.log("cartotal" + cartTotal);
        return (
            <div className="mobile-header">
                <div className="mobile-header__panel">
                    <div className="container">
                        <div className="mobile-header__body">
                            {!isHome && (
                                <button
                                    type="button"
                                    className="mobile-header__back"
                                    onClick={this.handleBack}
                                    aria-label="Kembali"
                                >
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="19" y1="12" x2="5" y2="12" />
                                        <polyline points="12 19 5 12 12 5" />
                                    </svg>
                                </button>
                            )}
                            <Search
                                context="mobile-header"
                                className="mobile-header__search"
                                inputRef={this.searchInput}
                                onClose={this.handleCloseSearch}
                            />
                            <div className="mobile-header__indicators">
                                <a
                                    href="https://api.whatsapp.com/send/?phone=+6281230553236&text=Hallo%20Hokky%20Bangunan%20saya%20mau%20tanya."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mobile-header__chat"
                                    aria-label="Chat WhatsApp CS Hokky Bangunan"
                                >
                                    <NavWhatsappIcon size={20} />
                                </a>
                                <Indicator
                                    className="indicator--mobile"
                                    url="/shop/cart"
                                    value={cartTotal}
                                    icon={<NavCartHeaderIcon size={21} />}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mobile-header__panels">
                    <div className="container">
                        <div className="mobile-header__bodys">
                        </div>
                    </div>
                </div>

                {/* <div className="mobile-header__panelss">
                    <div className="container">
                        <div className="mobile-header__bodyss">
                            <ReactPlayer 
                                url='https://hbs-sby.s3.ap-southeast-1.amazonaws.com/HOKKY+BANGUNAN+PROFILE+VIDEO.mp4'
                                pip={true}
                                muted={true}
                                loop={true}
                                playing={true}
                            />
                        </div>
                    </div>
                </div> */}

                {/* whatsapp */}

                {/* <FloatingWhatsApp
                    className="d-md-block d-lg-block d-xl-block d-none"
                    phoneNumber="081217853300"
                    accountName="Hokky Bangunan"
                    statusMessage= "Online 5 menit yang lalu"
                    chatMessage = "Selamat datang di Hokky Bangunan. Ada yang bisa saya Bantu ?"
                    avatar = "https://hbs-sby.s3.ap-southeast-1.amazonaws.com/logo_hokky.png"
                    allowClickAway
                /> */}

                {/* Navigasi Bawah Modern Melayang (4 Menu: Beranda, Kategori, Transaksi, Akun)
                    Disembunyikan pada halaman keranjang karena diganti floating checkout bar */}
                {!isCartPage && (
                    <nav className="nav-bawah-mobile navbar navbar-expand d-md-none fixed-bottom">
                        <ul className="navbar-nav nav-justified w-100">
                            {/* 1. Beranda */}
                            <li className="nav-item">
                                <Link
                                    to="/"
                                    className={classNames('nav-bawah-mobile__link', {
                                        'nav-bawah-mobile__link--active': currentPath === '/',
                                    })}
                                    aria-label="Beranda"
                                >
                                    <div className="nav-bawah-mobile__icon-wrap">
                                        <NavHomeIcon size={21} />
                                    </div>
                                    <span className="nav-bawah-mobile__label">Beranda</span>
                                </Link>
                            </li>

                            {/* 2. Kategori */}
                            <li className="nav-item">
                                <Link
                                    to="/shop/category"
                                    className={classNames('nav-bawah-mobile__link', {
                                        'nav-bawah-mobile__link--active': currentPath.startsWith('/shop/category') || currentPath.startsWith('/shop/catalog'),
                                    })}
                                    aria-label="Kategori"
                                >
                                    <div className="nav-bawah-mobile__icon-wrap">
                                        <NavCategoryIcon size={21} />
                                    </div>
                                    <span className="nav-bawah-mobile__label">Kategori</span>
                                </Link>
                            </li>

                            {/* 3. Transaksi (Histori Pesanan / Transaksi) */}
                            <li className="nav-item">
                                <Link
                                    to="/account/orders"
                                    className={classNames('nav-bawah-mobile__link', {
                                        'nav-bawah-mobile__link--active': currentPath.startsWith('/account/orders') || currentPath.startsWith('/accounts/order-produk'),
                                    })}
                                    aria-label="Riwayat Transaksi"
                                >
                                    <div className="nav-bawah-mobile__icon-wrap">
                                        <NavOrdersIcon size={21} />
                                    </div>
                                    <span className="nav-bawah-mobile__label">Transaksi</span>
                                </Link>
                            </li>

                            {/* 4. Akun */}
                            <li className="nav-item">
                                <Link
                                    to="/account/dashboard"
                                    className={classNames('nav-bawah-mobile__link', {
                                        'nav-bawah-mobile__link--active': currentPath.startsWith('/account/dashboard') || (currentPath.startsWith('/account') && !currentPath.startsWith('/account/orders') && !currentPath.startsWith('/accounts/order-produk')),
                                    })}
                                    aria-label="Akun Saya"
                                >
                                    <div className="nav-bawah-mobile__icon-wrap">
                                        <NavAccountIcon size={21} />
                                    </div>
                                    <span className="nav-bawah-mobile__label">Akun</span>
                                </Link>
                            </li>
                        </ul>
                    </nav>
                )}
            </div>
        );
        
    }
}

const mapStateToProps = (state) => ({
    cart: state.cart,
    wishlist: state.wishlist,
    token: state.auth.token,
    updateStatus: state.auth.update,
});

const mapDispatchToProps = {
    openMobileMenu: mobileMenuOpen,
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(MobileHeader));
